/* ================= Product entrance animation ================= */
var productIntro=(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarsePointer=window.matchMedia&&window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  var api={
    active:!reduce,
    yOffset:0,
    scale:1,
    rotX:0,
    rotY:0,
    rotZ:0,
    lookY:-0.15,
    wheelGlow:0,
    wheelSpin:0,
    update:update,
    play:function(){ return play(); },
    skip:function(){ played=true; finish(true); }
  };

  var start=performance.now();
  var duration=4800;
  var FRONT_THETA=0;
  var INTRO_RADIUS=21.2;
  var FINAL_RADIUS=14.0;
  var POST_INTRO_SCALE=0.70;
  var POST_INTRO_ROT_Z=THREE.MathUtils.degToRad(-5);
  var done=false;
  var played=false;
  var finishTimer=null;
  var baseKey=typeof repodKeyLight!=='undefined'?repodKeyLight.intensity:1.1;
  var baseFill=typeof repodFillLight!=='undefined'?repodFillLight.intensity:0.3;
  var baseRim=typeof repodRimLight!=='undefined'?repodRimLight.intensity:0.65;
  var revealLight=new THREE.PointLight(0xfff4df,0,10);
  var sweepLight=new THREE.PointLight(0xff4a17,0,8);
  var particleRig=new THREE.Group();
  var particleMat, particles;
  var screenFlashMat, screenFlash;

  function clamp01(v){ return Math.max(0,Math.min(1,v)); }
  function mixNum(a,b,t){ return a+(b-a)*t; }
  function smooth(a,b,t){
    t=clamp01((t-a)/(b-a));
    return t*t*(3-2*t);
  }
  function outCubic(t){
    t=clamp01(t);
    return 1-Math.pow(1-t,3);
  }
  function inOutCubic(t){
    t=clamp01(t);
    return t<0.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
  }
  function spring(t){
    t=clamp01(t);
    return 1-Math.exp(-6.6*t)*Math.cos(8.4*t);
  }
  function bell(t,center,width){
    var d=(t-center)/width;
    return Math.exp(-d*d);
  }

  function applyTransforms(){
    device.scale.setScalar(api.scale);
    device.rotation.x=api.rotX;
    device.rotation.y=api.rotY;
    device.rotation.z=api.rotZ;
  }

  function createParticleTexture() {
    var c = document.createElement('canvas');
    c.width = 32;
    c.height = 32;
    var x = c.getContext('2d');
    var grad = x.createRadialGradient(16, 16, 0, 16, 16, 16);
    grad.addColorStop(0, 'rgba(255,255,255,1)');
    grad.addColorStop(0.2, 'rgba(255,255,255,0.8)');
    grad.addColorStop(0.6, 'rgba(255,255,255,0.2)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    x.fillStyle = grad;
    x.fillRect(0, 0, 32, 32);
    var tex = new THREE.CanvasTexture(c);
    return tex;
  }

  function buildParticles(){
    var count=coarsePointer ? 180 : 650;
    var positions=new Float32Array(count*3);
    var colors=new Float32Array(count*3);
    for(var i=0;i<count;i++){
      var a=Math.random()*Math.PI*2;
      var r=1.15+Math.random()*4.95;
      var y=-3.9+Math.random()*8.5;
      positions[i*3]=Math.cos(a)*r;
      positions[i*3+1]=y;
      positions[i*3+2]=Math.sin(a)*r-0.25;
      var warm=Math.random()>0.86;
      colors[i*3]=warm?1.0:0.84+Math.random()*0.16;
      colors[i*3+1]=warm?0.54+Math.random()*0.12:0.90+Math.random()*0.10;
      colors[i*3+2]=warm?0.30+Math.random()*0.10:1.0;
    }
    var geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.BufferAttribute(positions,3));
    geo.setAttribute('color',new THREE.BufferAttribute(colors,3));
    particleMat=new THREE.PointsMaterial({
      size:coarsePointer ? 0.065 : 0.08,
      map: createParticleTexture(),
      vertexColors:true,
      transparent:true,
      opacity:0,
      sizeAttenuation:true,
      depthWrite:false,
      blending:THREE.AdditiveBlending
    });
    particles=new THREE.Points(geo,particleMat);
    particleRig.add(particles);
    scene.add(particleRig);
  }

  function buildFx(){
    revealLight.position.set(-0.4,2.6,5.4);
    sweepLight.position.set(-2.8,2.5,1.5);
    scene.add(revealLight);
    scene.add(sweepLight);

    screenFlashMat=new THREE.MeshBasicMaterial({
      color:0xf7fbff,
      transparent:true,
      opacity:0,
      depthWrite:false,
      depthTest:false,
      blending:THREE.AdditiveBlending
    });
    screenFlash=new THREE.Mesh(new THREE.PlaneGeometry(2.78,2.68),screenFlashMat);
    screenFlash.position.set(0,2.0,0.451);
    device.add(screenFlash);
  }

  function setUiProgress(progress){
    progress=clamp01(progress);
    var barsEl=document.getElementById('bars');
    if(barsEl){
      barsEl.style.opacity=String(progress);
      barsEl.style.transform='translateX(-50%) translateY('+Math.round((1-progress)*18)+'px)';
      barsEl.style.filter=coarsePointer ? 'none' : 'blur('+(4*(1-progress)).toFixed(2)+'px)';
    }
  }

  function restoreUi(){
    document.body.classList.remove('intro-running');
    document.body.classList.add('intro-ready');
    var barsEl=document.getElementById('bars');
    var introEl=document.getElementById('introStage');
    if(barsEl){
      barsEl.style.opacity='1';
      barsEl.style.transform='translateX(-50%)';
      barsEl.style.filter='none';
    }
    if(introEl){
      introEl.style.opacity='0';
    }
  }

  /* Starts the timeline from the top. Kept separate from the startup block so
     the entrance can be held back until the model is actually on screen. */
  function begin(){
    done=false;
    api.active=true;
    start=performance.now();
    document.body.classList.add('intro-running');
    document.body.classList.remove('intro-ready');
    theta=tTheta=-2.46;
    phi=tPhi=1.86;
    radius=tRadius=INTRO_RADIUS;
    api.yOffset=-3.30;
    api.scale=0.56;
    api.rotX=-0.24;
    api.rotY=0.62;
    api.rotZ=-0.20;
    api.lookY=-0.82;
    setUiProgress(0);
    applyTransforms();
    if(finishTimer){
      clearTimeout(finishTimer);
    }
    finishTimer=setTimeout(function(){ finish(false); },duration+500);
  }

  function play(){
    if(played) return false;
    played=true;
    if(reduce) return false;
    begin();
    return true;
  }

  function finish(instant){
    if(done) return;
    done=true;
    if(finishTimer){
      clearTimeout(finishTimer);
      finishTimer=null;
    }
    cleanUpBgParticles();
    api.active=false;
    api.yOffset=0;
    api.scale=POST_INTRO_SCALE;
    api.rotX=0;
    api.rotY=0;
    api.rotZ=POST_INTRO_ROT_Z;
    api.lookY=-0.15;
    api.wheelGlow=0;
    api.wheelSpin=0;
    applyTransforms();

    if(particleMat) particleMat.opacity=0;
    if(screenFlashMat) screenFlashMat.opacity=0;
    revealLight.intensity=0;
    sweepLight.intensity=0;
    if(typeof repodKeyLight!=='undefined') repodKeyLight.intensity=baseKey;
    if(typeof repodFillLight!=='undefined') repodFillLight.intensity=baseFill;
    if(typeof repodRimLight!=='undefined') repodRimLight.intensity=baseRim;

    theta=tTheta=FRONT_THETA;
    phi=tPhi=PH0;
    radius=tRadius=typeof R0!=='undefined'?R0:FINAL_RADIUS;
    lastInteract=performance.now();
    restoreUi();

    if(!instant) {
      if(typeof window.repodPlayHandHint === 'function') {
        setTimeout(window.repodPlayHandHint, 800);
      }
    }

    if(typeof showGameArrows==='function'){
      setTimeout(function(){
        if(APP===gameApp) showGameArrows();
      },instant?180:520);
    }
  }

  var bgCanvas = null;
  var bgCtx = null;
  var bgParticles = [];
  var bgParticlesInitialized = false;

  function initBgParticles() {
    bgCanvas = document.getElementById('introBgCanvas');
    if (!bgCanvas) return;
    bgCtx = bgCanvas.getContext('2d');
    resizeBgCanvas();
    window.addEventListener('resize', resizeBgCanvas);

    var count = coarsePointer ? 18 : 45;
    bgParticles = [];
    for (var i = 0; i < count; i++) {
      bgParticles.push({
        x: Math.random() * bgCanvas.width,
        y: Math.random() * bgCanvas.height,
        size: Math.random() * (coarsePointer ? 4 : 5) + 2,
        speedY: -(Math.random() * (coarsePointer ? 0.55 : 0.8) + 0.35),
        speedX: (Math.random() - 0.5) * (coarsePointer ? 0.25 : 0.4),
        alpha: Math.random() * 0.5 + 0.1,
        pulseSpeed: Math.random() * 0.02 + 0.01,
        pulseOffset: Math.random() * Math.PI * 2
      });
    }
    bgParticlesInitialized = true;
  }

  function resizeBgCanvas() {
    if (!bgCanvas) return;
    var rect = bgCanvas.parentElement.getBoundingClientRect();
    bgCanvas.width = rect.width;
    bgCanvas.height = rect.height;
  }

  function updateAndDrawBgParticles(now, t) {
    if (!bgParticlesInitialized || !bgCtx || !bgCanvas) return;
    
    bgCtx.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
    
    var overallFade = 1;
    if (t > 0.75) {
      overallFade = (1 - t) / 0.25;
    }
    
    for (var i = 0; i < bgParticles.length; i++) {
      var p = bgParticles[i];
      p.y += p.speedY;
      p.x += p.speedX;
      
      if (p.y < -10) p.y = bgCanvas.height + 10;
      if (p.x < -10) p.x = bgCanvas.width + 10;
      if (p.x > bgCanvas.width + 10) p.x = -10;
      
      var currentAlpha = p.alpha * (0.7 + 0.3 * Math.sin(now * p.pulseSpeed + p.pulseOffset)) * overallFade;
      
      bgCtx.beginPath();
      var grad = bgCtx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size);
      if (i % 3 === 0) {
        grad.addColorStop(0, 'rgba(254, 94, 16, ' + currentAlpha + ')');
        grad.addColorStop(0.5, 'rgba(254, 163, 112, ' + (currentAlpha * 0.4) + ')');
        grad.addColorStop(1, 'rgba(254, 94, 16, 0)');
      } else {
        grad.addColorStop(0, 'rgba(255, 244, 223, ' + currentAlpha + ')');
        grad.addColorStop(0.6, 'rgba(255, 255, 255, ' + (currentAlpha * 0.3) + ')');
        grad.addColorStop(1, 'rgba(255, 255, 255, 0)');
      }
      bgCtx.fillStyle = grad;
      bgCtx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      bgCtx.fill();
    }
  }

  function cleanUpBgParticles() {
    window.removeEventListener('resize', resizeBgCanvas);
    if (bgCtx && bgCanvas) {
      bgCtx.clearRect(0, 0, bgCanvas.width, bgCanvas.height);
    }
    bgParticles = [];
    bgParticlesInitialized = false;
  }

  function update(now){
    if(done) return;
    var t=clamp01((now-start)/duration);
    var silhouette=smooth(0.00,0.22,t);
    var reveal=smooth(0.10,0.55,t);
    var lock=smooth(0.42,0.90,t);
    var settle=smooth(0.58,1.00,t);
    var springLock=spring(lock);
    var bodySweep=smooth(0.18,0.58,t)*(1-smooth(0.66,0.88,t));
    var heroFlash=bell(t,0.53,0.09);
    var wheelTravel=inOutCubic(smooth(0.50,0.80,t));
    var wheelAccent=smooth(0.49,0.70,t)*(1-smooth(0.78,0.94,t));
    var glintPulse=bell(t,0.33,0.08)+bell(t,0.58,0.10)+bell(t,0.72,0.08);
    var uiFade=smooth(0.82,1.00,t);

    tTheta=mixNum(-2.46,FRONT_THETA,inOutCubic(smooth(0.02,0.82,t)));
    tPhi=mixNum(1.86,PH0,inOutCubic(smooth(0.04,0.86,t)));
    var turnEmphasis=bell(t,0.48,0.18);
    tRadius=mixNum(INTRO_RADIUS,typeof R0!=='undefined'?R0:FINAL_RADIUS,outCubic(smooth(0.08,0.96,t)))-0.55*turnEmphasis;

    api.lookY=mixNum(-0.82,-0.15,smooth(0.25,0.82,t));
    api.yOffset=mixNum(-3.30,0.04,outCubic(reveal))-0.04*settle;
    api.yOffset+=Math.sin(now*0.0075)*0.032*(1-settle);
    api.scale=mixNum(0.56,POST_INTRO_SCALE,outCubic(smooth(0.08,0.92,t)));
    api.rotX=mixNum(-0.24,0,springLock);
    api.rotY=mixNum(0.62,0,springLock);
    api.rotZ=mixNum(-0.20,POST_INTRO_ROT_Z,outCubic(reveal))+Math.sin(lock*Math.PI*2.1)*0.035*(1-settle);
    api.wheelGlow=clamp01(wheelAccent*0.55+bodySweep*0.08+heroFlash*0.22);
    api.wheelSpin=outCubic(smooth(0.34,0.82,t))*Math.PI*2.85;

    if(typeof repodKeyLight!=='undefined') repodKeyLight.intensity=baseKey*(0.58+0.42*smooth(0.36,0.96,t));
    if(typeof repodFillLight!=='undefined') repodFillLight.intensity=baseFill*(0.34+0.66*smooth(0.58,1.00,t));
    if(typeof repodRimLight!=='undefined') repodRimLight.intensity=baseRim+0.58*bell(t,0.42,0.22);

    revealLight.intensity=2.0*silhouette*(1-smooth(0.78,1.00,t));
    revealLight.position.x=mixNum(-1.1,1.2,smooth(0.10,0.74,t));
    revealLight.position.y=mixNum(1.2,3.3,smooth(0.06,0.56,t));
    var sweepTravel=inOutCubic(smooth(0.14,0.76,t));
    var sweepLift=Math.sin(sweepTravel*Math.PI);
    var sweepRipple=Math.sin(sweepTravel*Math.PI*2.4);
    sweepLight.intensity=1.35*bodySweep+0.32*glintPulse;
    sweepLight.position.x=mixNum(-2.75,2.35,sweepTravel)+0.36*sweepRipple;
    sweepLight.position.y=mixNum(2.72,-2.28,sweepTravel)+0.48*sweepLift;
    sweepLight.position.z=1.10+0.82*sweepLift;

    if(particleMat){
      particleMat.opacity=clamp01(0.85*smooth(0.00,0.20,t)*(1-smooth(0.76,0.99,t))+0.15*glintPulse);
      particleMat.size=mixNum(0.12,0.06,smooth(0.22,0.88,t))+0.015*clamp01(glintPulse);
    }
    if(particleRig){
      particleRig.rotation.y+=0.0064+0.0022*wheelAccent;
      particleRig.rotation.z=Math.sin(now*0.0012)*0.075;
      particleRig.scale.setScalar(mixNum(1.20,0.82,smooth(0.10,0.86,t)));
      particleRig.position.y=mixNum(-0.34,0.12,smooth(0.20,0.80,t));
    }
    if(screenFlashMat) screenFlashMat.opacity=0.30*heroFlash;

    setUiProgress(uiFade);
    updateAndDrawBgParticles(now, t);

    applyTransforms();
    if(t>=1) finish(false);
  }

  /* True when the shared model is homed in the homepage experience stage
     instead of the banner, i.e. the banner renders no model of its own. */
  function modelHomeIsExperience(){
    var product=document.querySelector('.hero__product');
    return !!(product && product.closest('[data-repod-experience]'));
  }

  if(typeof hideGameArrows==='function') hideGameArrows();

  if(!reduce){
    /* The reveal/sweep lights and the particle rig are created up front: adding
       lights grows the light count, which makes the renderer compile new
       programs, and that hitch must not land on the first visible frame. */
    buildParticles();
    buildFx();
  }

  if(reduce||modelHomeIsExperience()){
    /* Park the device in its finished pose. When the model lives in the
       experience stage the whole entrance is started by that section once it
       scrolls into view — the timeline would otherwise burn off below the fold
       and then be cut short the moment the model landed on the stage. */
    finish(true);
  }else{
    played=true;
    initBgParticles();
    begin();
  }

  return api;
})();
